/** Hero & home section — URLs verified (HTTP 200). */
export const HERO_IMAGE =
  'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1200&q=85';

export const HOME_ABOUT_MAIN_IMAGE =
  '/images/home/home-about-main-20260214.jpg';

export const HOME_BACKGROUND_IMAGE = '/images/home/home-group-bg.jpg';
